import { render, staticRenderFns } from "./BreadcrumbsComponent.vue?vue&type=template&id=4703beb1&"
import script from "./BreadcrumbsComponent.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbsComponent.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbsComponent.vue?vue&type=style&index=0&id=4703beb1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports